import { render, staticRenderFns } from "./VerificationList.vue?vue&type=template&id=8179917e&scoped=true&"
import script from "./VerificationList.vue?vue&type=script&lang=js&"
export * from "./VerificationList.vue?vue&type=script&lang=js&"
import style0 from "./VerificationList.vue?vue&type=style&index=0&id=8179917e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8179917e",
  null
  
)

export default component.exports